export default __webpack_public_path__ + "static/media/amazon.8a708a0e.svg";